import React, { useEffect, useState } from "react";
import PlanningPage from "./planningPage";
import { containerStatusList, containerTypeList } from "../StaticData";
import BookingsApi from "../state/bookings-api";
import { AgUnlocCH } from "../components/AgComponents";
import { configStore, dataListStore } from "../state/CommonState";
import { loader } from "../util/loader";
import ContainerListPopup from "./containerListPopup";
import Api from "../state/Api";
import TableFilter from "../components/ag-table/TableFilter";

const PlanningConsole = () => {
  const [selectedTab, setSelectedTab] = useState("To be Planned");
  const [showPopup, setShowPopup] = useState(false);
  const [containerStatus, setContainerStatus] = useState('Planned')
  const [shipmentType, setShipmentType] = useState("LCL");
  const [validationCalled, setValidationCalled] = useState(false);
  const [refreshAlert, setRefreshAlert] = useState(0)
  const [openContainerViewPopup, setOpenContainerViewPopup] = useState(false);
  const [selectStatus, setSelectStatus] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [search, setSearch] = useState(false);
  const [newContainer, setNewContainer] = useState({
    _id: '',
    stuffing_cutoff: "",
    pol_container_number: "",
    containerList: [],
    containerType: "",
    mblNumber: "",
    vessel: "",
    voyage: "",
    carrier: "",
    containerStatus: "Planned",
    por: "",
    pol: "",
    pod: "",
    fpod: "",
    etd_pol: "",
    eta_pol: "",
  });
  const isValidLocation = (value) => {
    return value && value.indexOf('(') !== -1 && value.indexOf(')') !== -1;
  };

  const isValidContainer = (value) => {
    if (!value) return true;
    return /^[A-Z]{4}[0-9]{7}$/.test(value);
  };

  const onClickFilterCallback = (filter) => {
    setKeyword(filter)
  }

  const onClickSearch = () => {
    if (keyword.length > 0) {
      setSearch(true)
    } else {
      configStore.setModalMessage(`Please Provide Valid Input`)
    }
  };

  const searchCallback = () => {
    setSearch(false)
  }

  useEffect(() => {
    Api.getFCLCarrierList();
  }, [shipmentType, showPopup]);

  const tabList = ["To be Planned", "Planned", "Confirmation", "Stuffed"];

  const handleSave = async () => {
    loader.show()
    setValidationCalled(true);

    const {
      stuffing_cutoff,
      pol_container_number,
      containerType,
      mblNumber,
      vessel,
      voyage,
      carrier,
      containerStatus,
      por,
      pol,
      pod,
      fpod,
      etd_pol,
      eta_pol,
      agentSeal,
      agentName,
      agentAddress,
      customsSeal,
      containerList
    } = newContainer;

    const isContainerValid = /^[A-Z]{4}[0-9]{7}$/.test(pol_container_number);

    const isValid =
      isValidLocation(por) &&
      isValidLocation(pol) &&
      isValidLocation(pod) &&
      isValidLocation(fpod) &&
      (shipmentType === 'LCL' ? isValidContainer(pol_container_number) : containerList.length > 0 && containerList.every(c => isValidContainer(c.container_number)))


    const isStuffedValid =
      (por === pol || eta_pol) &&
      (etd_pol || containerStatus !== 'Stuffed') &&
      isContainerValid &&
      stuffing_cutoff &&
      containerType &&
      mblNumber &&
      vessel &&
      voyage &&
      carrier &&
      containerStatus &&
      agentSeal &&
      agentName &&
      agentAddress &&
      customsSeal

    if (!isValid) {
      configStore.setModalMessage("Please fill all required fields correctly.");
      loader.hide()
      return;
    }

    if (shipmentType !== 'FCL' && containerStatus !== 'Planned' && containerStatus !== 'Stuffing In-Progress' && !isStuffedValid) {
      configStore.setModalMessage("Please fill all required fields correctly.");
      loader.hide()
      return;
    } else if (shipmentType === 'FCL' && selectStatus === 'Confirmation' && !isStuffedValid) {
      configStore.setModalMessage("Please fill all required fields correctly.");
      loader.hide()
      return;
    }
    newContainer.shipmentType = shipmentType;

    try {
      BookingsApi.updateContainer(newContainer, (res) => {
        if (!res?.message) {
          setShowPopup(false);
          setContainerStatus('Planned')
          setNewContainer({
            _id: '',
            stuffing_cutoff: "",
            pol_container_number: "",
            containerType: "",
            mblNumber: "",
            vessel: "",
            voyage: "",
            carrier: '',
            agentSeal: '',
            agentName: '',
            agentAddress: '',
            customsSeal: '',
            por: "",
            pol: "",
            containerlist: [],
            containerStatus: 'Planned',
            pod: "",
            fpod: "",
            etd_pol: "",
            eta_pol: "",
          });
          setValidationCalled(false);
           setValidationCalled(false);
        setRefreshAlert(prev => prev + 1);
        setSearch(search);
        loader.hide()
        }
      });
    } catch (error) {
      loader.hide()
      console.error("Error saving container:", error);
      alert("Failed to save container.");
    } finally{
       loader.hide()
    }
  };

  const inputStyle = (field) =>
    validationCalled && newContainer.containerStatus === 'Stuffed' && !field ? { border: "1px solid red" } : {};

  const containerNumStyle = (value) =>
    validationCalled && value && !/^[A-Z]{4}[0-9]{7}$/.test(value)
      ? { border: "1px solid red" }
      : {};


  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <h2 className="title">Console Planning</h2>
        <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: "auto" }}>
          <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: "10px" }}>
            <TableFilter onClickSearch={onClickSearch} onClickFilterCallback={onClickFilterCallback} defaultKeyword={keyword} />
          </div>
          {shipmentType === 'LCL' && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}><button
            className="button is-primary"
            onClick={() => {
              setShowPopup(true);
              setSelectStatus(true);
            }}
            style={{
              padding: "8px 16px",
              backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
              height: "40px",
            }}
          >
            + Add New Container
          </button>

            <button
              className="button is-info"
              style={{
                backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                height: "40px",
              }}
              onClick={() => setOpenContainerViewPopup(true)}
            >
              📦 View All Containers
            </button>
          </div>}
          <div className="field">
            <p className="control has-icons-left has-icons-right">
              <span className="select">
                <select name="status" id="status" onChange={(e) => {
                  setShipmentType(e.target.value)
                  setSearch(true)
                }}>
                  <option value="LCL">LCL</option>
                  <option value="FCL">FCL</option>
                </select>
                <span className="icon"><i className="fa-solid fa-filter"></i></span>
              </span>
            </p>
          </div>
        </div>
      </div>



      <div style={{ width: "100%" }}>
        <div className="w-full h-[40px] bg-blue-dark rounded-t-md flex flex-row">
          {tabList.map((type) => (
            <div
              key={type}
              onClick={() => {
                setSelectedTab(type)
                setSearch(true)
              }}
              className={`h-full text-white font-bold text-[18px] flex items-center justify-center hover:cursor-pointer ${type === selectedTab ? "bg-yellow" : ""
                }`}
              style={{ width: "15%" }}
            >
              {type}
            </div>
          ))}
        </div>
      </div>

      <PlanningPage search={search} keyword={keyword} searchCallback={searchCallback} tab={selectedTab} refreshAlert={refreshAlert} shipmentType={shipmentType} setShowPopup={setShowPopup} setSelectStatus={setSelectStatus}
        openContainerPopup={(container) => {
          setSelectStatus(false)
          setContainerStatus(container.containerStatus)
          setNewContainer(container);
          setShowPopup(true);
        }} />

      {openContainerViewPopup && (
        <ContainerListPopup
          onClose={() => setOpenContainerViewPopup(false)}
          onEdit={(container) => {
            setSelectStatus(true)
            setContainerStatus(container.containerStatus);
            setNewContainer(container);
            setShowPopup(true);
            setOpenContainerViewPopup(false);
          }}
        />
      )}


      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex", justifyContent: "center", alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div style={{
            backgroundColor: "#fff",
            padding: 24,
            borderRadius: 8,
            width: "750px",
            maxHeight: "90vh",
            overflowY: "auto",
          }}>
            <h2 style={{ marginBottom: 16, fontSize: 20, fontWeight: "bold" }}>
              {shipmentType === 'LCL' ? (newContainer._id ? `Plan Slip - tag No. ${newContainer._id}` : `Add New Plan Slip`) : `Plan Slip - Booking No. ${newContainer._id}`}
            </h2>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
              {["por", "pol", "pod", "fpod"].map((loc) => (
                <AgUnlocCH
                  isDisabled={newContainer._id || shipmentType === 'FCL'}
                  key={loc}
                  shipmentType={shipmentType}
                  label={loc.toUpperCase()}
                  name={loc}
                  callback={(val) => setNewContainer((prev) => ({ ...prev, [loc]: val.trim() }))}
                  value={newContainer[loc]}
                  isValid={validationCalled ? isValidLocation(newContainer[loc]) : true}
                  validationMsg={`* ${loc.toUpperCase()} invalid`}
                />
              ))}

              <div style={{ flex: "1 1 45%" }}>
                <label className="label is-small">Stuffing Cut-Off</label>
                <input
                  disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                  type="datetime-local"
                  value={newContainer.stuffing_cutoff}
                  onChange={(e) => setNewContainer({ ...newContainer, stuffing_cutoff: e.target.value })}
                  style={inputStyle(newContainer.stuffing_cutoff)}
                  className="input is-small"
                />
              </div>

              {newContainer.por && newContainer.pol && newContainer.por !== newContainer.pol &&

                <div style={{ flex: "1 1 45%" }}>
                  <label className="label is-small">ETA @ POL</label>
                  <input
                    disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                    type="date"
                    value={newContainer.eta_pol}
                    onChange={(e) => setNewContainer({ ...newContainer, eta_pol: e.target.value })}
                    style={inputStyle(newContainer.eta_pol)}
                    className="input is-small"
                  />
                </div>}

              {

                <div style={{ flex: "1 1 45%" }}>
                  <label className="label is-small">ETD @ POL</label>
                  <input
                    disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                    type="date"
                    value={newContainer.etd_pol}
                    onChange={(e) => setNewContainer({ ...newContainer, etd_pol: e.target.value })}
                    style={inputStyle(newContainer.etd_pol)}
                    className="input is-small"
                  />
                </div>}

              {shipmentType !== "FCL" ? (
                <>
                  <div style={{ flex: "1 1 45%" }}>
                    <label className="label is-small">Container Number</label>
                    <input
                      type="text"
                      placeholder="ABCD1234567"
                      maxLength={11}
                      minLength={11}
                      disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                      value={newContainer.pol_container_number}
                      onChange={(e) => {
                        const val = e.target.value.toUpperCase();
                        if (/^[A-Z]{0,4}[0-9]{0,7}$/.test(val) || val === "") {
                          setNewContainer({ ...newContainer, pol_container_number: val });
                        }
                      }}
                      style={containerNumStyle(newContainer.pol_container_number)}
                      className="input is-small"
                    />
                  </div>

                  <div style={{ flex: "1 1 45%" }}>
                    <label className="label is-small">Container Type</label>
                    <select
                      value={newContainer.containerType}
                      disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                      onChange={(e) => setNewContainer({ ...newContainer, containerType: e.target.value })}
                      style={inputStyle(newContainer.containerType)}
                      className="input is-small"
                    >
                      <option value="">Select Container Type</option>
                      {containerTypeList.map((type) => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                </>

              ) : (
                <div style={{ flex: "1 1 100%" }}>
                  <table className="table is-bordered is-fullwidth is-narrow">
                    <thead>
                      <tr>
                        <th>Container Number</th>
                        <th>Container Type</th>
                        <th>Agent Seal Number</th>
                        <th>Custom Seal Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {newContainer.containerList?.map((field, i) => (
                        <tr key={i}>
                          <td>
                            <input
                              type="text"
                              placeholder="ABCD1234567"
                              maxLength={11}
                              minLength={11}
                              disabled={
                                newContainer.containerStatus !== "Planned" &&
                                newContainer.containerStatus !== "Stuffing In-Progress"
                              }
                              style={containerNumStyle(field.container_number)}
                              value={field.container_number || ""}
                              onChange={(e) => {
                                const val = e.target.value.toUpperCase();
                                if (/^[A-Z]{0,4}[0-9]{0,7}$/.test(val) || val === "") {
                                  const updatedList = [...newContainer.containerList];
                                  updatedList[i].container_number = val;
                                  setNewContainer({
                                    ...newContainer,
                                    containerList: updatedList,
                                  });
                                }
                              }}
                              className="input is-small"
                            />
                          </td>

                          <td>
                            <select
                              value={field.container_types}
                              disabled={
                                newContainer.containerStatus !== "Planned" &&
                                newContainer.containerStatus !== "Stuffing In-Progress"
                              }
                              onChange={(e) => {
                                const updatedList = [...newContainer.containerList];
                                updatedList[i].container_types = e.target.value;
                                setNewContainer({
                                  ...newContainer,
                                  containerList: updatedList,
                                });
                              }}
                              style={inputStyle(field.container_type)}
                              className="input is-small"
                            >
                              <option value="">Select Container Type</option>
                              {containerTypeList.map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td >
                            <input
                              type="text"
                              maxLength={15}
                              value={field.agentSeal}
                              disabled={
                                newContainer.containerStatus !== "Planned" &&
                                newContainer.containerStatus !== "Stuffing In-Progress"
                              }
                              onChange={(e) => {
                                const updatedList = [...newContainer.containerList];
                                updatedList[i].agentSeal = e.target.value;
                                setNewContainer({
                                  ...newContainer,
                                  containerList: updatedList,
                                });
                              }}
                              style={inputStyle(newContainer.agentSeal)}
                              className="input is-small"

                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              maxLength={15}
                              disabled={
                                newContainer.containerStatus !== "Planned" &&
                                newContainer.containerStatus !== "Stuffing In-Progress"
                              }
                              value={field.customsSeal}
                              onChange={(e) => {
                                const updatedList = [...newContainer.containerList];
                                updatedList[i].customsSeal = e.target.value;
                                setNewContainer({
                                  ...newContainer,
                                  containerList: updatedList,
                                });
                              }}
                              style={inputStyle(newContainer.customsSeal)}
                              className="input is-small"

                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div style={{ flex: "1 1 45%" }}>
                <label className="label is-small">MBL Number</label>
                <input
                  type="text"
                  maxLength={15}
                  disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                  value={newContainer.mblNumber}
                  onChange={(e) => setNewContainer({ ...newContainer, mblNumber: e.target.value })}
                  style={inputStyle(newContainer.mblNumber)}
                  className="input is-small"
                />
              </div>

              <div style={{ flex: "1 1 45%" }}>
                <label className="label is-small">Vessel</label>
                <input
                  type="text"
                  disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                  maxLength={30}
                  value={newContainer.vessel}
                  onChange={(e) => setNewContainer({ ...newContainer, vessel: e.target.value })}
                  style={inputStyle(newContainer.vessel)}
                  className="input is-small"
                />
              </div>

              <div style={{ flex: "1 1 45%" }}>
                <label className="label is-small">Voyage</label>
                <input
                  disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                  type="text"
                  maxLength={15}
                  value={newContainer.voyage}
                  onChange={(e) => setNewContainer({ ...newContainer, voyage: e.target.value })}
                  style={inputStyle(newContainer.voyage)}
                  className="input is-small"
                />
              </div> <div style={{ flex: "1 1 45%" }}>
                <label className="label is-small">Carrier</label>
                <select
                  disabled={newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                  value={newContainer.carrier}
                  onChange={(e) => setNewContainer({ ...newContainer, carrier: e.target.value })}
                  style={inputStyle(newContainer.carrier)}
                  className="input is-small"
                >
                  <option value="">-- Select Carrier --</option>
                  {dataListStore["FCLCarrierList"]?.map((carrier, idx) => (
                    <option key={idx} value={`${carrier['Display Name']} (${carrier['SCAC code']})`}>{`${carrier['Display Name']} (${carrier['SCAC code']})`}</option>
                  ))}
                </select>
              </div>

              {shipmentType !== 'FCL' && <div style={{ flex: "1 1 45%" }}>
                <label className="label is-small">Container Status</label>
                <select
                  value={newContainer.containerStatus}
                  disabled={!selectStatus}
                  onChange={(e) => setNewContainer({ ...newContainer, containerStatus: e.target.value })}
                  style={inputStyle(newContainer.containerStatus)}
                  className="input is-small"
                >
                  {containerStatusList
                    .filter((_, index) => {
                      const currentIndex = containerStatusList.indexOf(containerStatus);
                      return index === currentIndex || index === currentIndex + 1;
                    })
                    .map((type) => (
                      <option key={type} value={type}>{type}</option>
                    ))
                  }
                </select>
              </div>}

              {((newContainer.containerStatus !== 'Planned' && newContainer.containerStatus !== 'Stuffing In-Progress') || shipmentType === 'FCL') && <>
                {shipmentType !== 'FCL' && <div style={{ flex: "1 1 45%" }}>
                  <div>
                    <label className="label is-small">Custom Seal Number</label>
                    <input
                      type="text"
                      maxLength={15}
                      disabled={newContainer.containerStatus !== 'Stuffed' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                      value={newContainer.customsSeal}
                      onChange={(e) => setNewContainer({ ...newContainer, customsSeal: e.target.value })}
                      style={inputStyle(newContainer.customsSeal)}
                      className="input is-small"

                    />
                  </div>
                  <div style={{ flex: "1 1 45%" }}>
                    <label className="label is-small">Agent Seal Number</label>
                    <input
                      type="text"
                      maxLength={15}
                      value={newContainer.agentSeal}
                      disabled={newContainer.containerStatus !== 'Stuffed' && newContainer.containerStatus !== 'Stuffing In-Progress'}
                      onChange={(e) => setNewContainer({ ...newContainer, agentSeal: e.target.value })}
                      style={inputStyle(newContainer.agentSeal)}
                      className="input is-small"

                    />
                  </div>
                </div>
                }
                <div style={{ flex: "1 1 45%" }}>
                  <label className="label is-small">Agent Name</label>
                  <input
                    type="text"
                    maxLength={15}
                    value={newContainer.agentName}
                    disabled={selectedTab === 'Stuffed' || (newContainer.containerStatus === 'Sealed' ||newContainer.containerStatus === 'Sailed')}
                    onChange={(e) => setNewContainer({ ...newContainer, agentName: e.target.value })}
                    style={inputStyle(newContainer.agentName)}
                    className="input is-small"

                  />
                </div>
                <div style={{ flex: "1 1 45%" }}>
                  <label className="label is-small">Agent Address</label>
                  <input
                    type="text"
                    maxLength={15}
                    value={newContainer.agentAddress}
                    disabled={selectedTab === 'Stuffed'|| (newContainer.containerStatus === 'Sealed' ||newContainer.containerStatus === 'Sailed')}
                    onChange={(e) => setNewContainer({ ...newContainer, agentAddress: e.target.value })}
                    style={inputStyle(newContainer.agentAddress)}
                    className="input is-small"

                  />
                </div>
              </>}
            </div>

            <div style={{ marginTop: 20, display: "flex", justifyContent: "flex-end", gap: 12 }}>
              <button className="button is-danger" onClick={() => {
                setValidationCalled(false);
                setSelectStatus(false); 
                setNewContainer({
                  _id: '',
                  stuffing_cutoff: "",
                  pol_container_number: "",
                  containerList: [],
                  containerType: "",
                  mblNumber: "",
                  vessel: "",
                  voyage: "",
                  carrier: '',
                  containerStatus: "Planned",
                  por: "",
                  pol: "",
                  pod: "",
                  fpod: "",
                  etd_pol: "",
                  eta_pol: "",
                })
                setContainerStatus('Planned')
                setShowPopup(false)
                setRefreshAlert(refreshAlert + 1)
              }}>Close</button>
              <button className="button is-success" disabled={containerStatus === 'Sailed'} style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON }} onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PlanningConsole;
